/**
 * Attempt to calculate the correct ratio for an iframe embed
 * @param  {Node} el Wrapping element for iframe
 */
export default function responsiveEmbed(el) {
  const iframe = el.querySelector("iframe");
  if (!iframe) {
    return;
  }
  let ratio = calculateRatio(iframe);
  if (ratio) {
    el.style.paddingBottom = `${ratio * 100}%`;
  }
}

function calculateRatio(iframe) {
  const width = iframe.width;
  const height = iframe.height;
  if (height && width) {
    return height / width;
  }
  return false;
}
